import {Body2} from '@ui/atoms/typography';
import {ToggleSwitch} from '@ui/atoms/toggle-switch';
import {Image} from '@ui/atoms/image';
import {emojiList} from '@ui/assets/emojis';
import {MinusIcon} from '@ui/atoms/icons';
import {
  BlockContent,
  BlockDragRail,
  QuestionCard,
  DragIcon,
  QuestionBlockHeader,
  QuestionTypePill,
  PulseRow,
  PulseEmoji,
  PulseLabel,
  ToggleRow,
  RemoveRow,
  RemoveIcon,
} from './content-step.styles';
import {ContentBlock, PulseBlockData} from './types';

interface PulseBlockProps {
  block: Extract<ContentBlock, {type: 'pulse'}>;
  blocks: ContentBlock[];
  pulseOptions: {key: string; label: string}[];
  dragHandleProps: any;
  isDragging: boolean;
  onBlocksChange: (blocks: ContentBlock[]) => void;
  onRemove: () => void;
  createPulseData: () => PulseBlockData;
}

export const PulseBlock = ({
  block,
  blocks,
  pulseOptions,
  dragHandleProps,
  isDragging,
  onBlocksChange,
  onRemove,
  createPulseData,
}: PulseBlockProps) => {
  return (
    <QuestionCard isDragging={isDragging} data-block-type={block.type}>
      <BlockDragRail {...dragHandleProps} aria-label="Reorder pulse">
        <DragIcon aria-hidden="true">⠿</DragIcon>
      </BlockDragRail>
      <BlockContent>
        <QuestionBlockHeader>
          <QuestionTypePill variant="pulse">Pulse</QuestionTypePill>
          <RemoveRow onClick={onRemove} aria-label="Remove pulse">
            <RemoveIcon>
              <MinusIcon />
            </RemoveIcon>{' '}
            Remove
          </RemoveRow>
        </QuestionBlockHeader>
        <div className="flex gap-2 flex-col">
          <Body2 kind="blackTwo" weight="semibold">
            {block.pulseData?.name ||
              'How are you feeling about your workload this week?'}
          </Body2>
          <PulseRow>
            {pulseOptions.map(({key, label}) => (
              <PulseEmoji key={key}>
                <div className="emojiIcon">
                  <Image {...(emojiList as any)[key]} />
                </div>
                <PulseLabel>{label}</PulseLabel>
              </PulseEmoji>
            ))}
          </PulseRow>
          <ToggleRow>
            <ToggleSwitch
              togglWidth="sm"
              checked={block.pulseData?.required ?? true}
              onChange={(event) =>
                onBlocksChange(
                  blocks.map((b) => {
                    if (b.id !== block.id || b.type !== 'pulse') {
                      return b;
                    }
                    return {
                      ...b,
                      pulseData: {
                        ...(b.pulseData || createPulseData()),
                        required: event.target.checked,
                      },
                    };
                  }),
                )
              }
            />
            <Body2 kind="blackTwo" weight="semibold">
              Required
            </Body2>
          </ToggleRow>
        </div>
      </BlockContent>
    </QuestionCard>
  );
};
